<template>
  <div id="myDateShow">
    <div class="title">查看 商品资料</div>
    <div id="dataShow">
      <div class="line">
        <div class="key">商品分类</div>
        <div class="value">{{skuInfo.pmsSkuClassify.classifyName}}</div>
      </div>
      <div class="line">
        <div class="key">商品活动类型</div>
        <div class="value">{{skuInfo.activityClassify}}</div>
      </div>
      <div class="line" v-if="skuInfo.activityClassify=='秒购商品'">
        <div class="key">商品秒购价</div>
        <div class="value">{{skuInfo.seckillPrice}}</div>
      </div>
      <div class="line" v-if="skuInfo.activityClassify=='秒购商品'">
        <div class="key">秒购开始时间</div>
        <div class="value">{{skuInfo.seckillStartDate}}</div>
      </div>
      <div class="line" v-if="skuInfo.activityClassify=='秒购商品'">
        <div class="key">秒购结束时间</div>
        <div class="value">{{skuInfo.seckillEndDate}}</div>
      </div>
      <div class="line">
        <div class="key">商品名称</div>
        <div class="value">{{skuInfo.skuName}}</div>
      </div>
      <div class="line">
        <div class="key">商品副标题</div>
        <div class="value">{{skuInfo.skuTitle}}</div>
      </div>
      <div class="line">
        <div class="key">商品详情</div>
        <div class="value">{{skuInfo.skuDetail}}</div>
      </div>
      <div class="line">
        <div class="key">所属农基商</div>
        <div class="value">{{skuInfo.merchants.merchantsName}}</div>
      </div>
      <div class="line">
        <div class="key">出产地</div>
        <div class="value">{{skuInfo.skuProducers}}</div>
      </div>
      <div class="line">
        <div class="key">生产日期</div>
        <div class="value">{{skuInfo.skuProductionDate}}</div>
      </div>
      <div class="line">
        <div class="key">计价单位</div>
        <div class="value">{{skuInfo.skuWeight}}</div>
      </div>
      <div class="line">
        <div class="key">售价</div>
        <div class="value">{{skuInfo.skuPrice}}</div>
      </div>
      <div class="line">
        <div class="key">库存</div>
        <div class="value">{{skuInfo.skuInventory}}</div>
      </div>
      <div class="line">
        <div class="key">商品存放建议</div>
        <div class="value">{{skuInfo.storeAdvice}}</div>
      </div>
      <div class="line">
        <div class="key">商品包邮说明</div>
        <div class="value">{{skuInfo.postageInstructions}}</div>
      </div>
      <div class="line">
        <div class="key">商品额外信息</div>
        <div class="value">{{skuInfo.skuNote}}</div>
      </div>
      <div class="line">
        <div class="key">商品标签</div>
        <div class="value" v-for="item in skuInfo.labelValues">
          <div class="tag">
            <span>{{item.labelName}}</span>
          </div>
        </div>
      </div>
      <div class="line">
        <div class="key">状态</div>
        <div class="value" v-if="skuInfo.isShelves=='0'">上架</div>
        <div class="value" v-else-if="skuInfo.isShelves=='1'">下架</div>
        <div class="value" v-else>封仓</div>
      </div>
      <div class="line">
        <div class="key">服务</div>
        <div class="value" v-for="item in skuInfo.pmsExtras">{{item.extraService}}</div>
      </div>
      <div class="line">
        <div class="key">商品主图</div>
        <div class="value">
          <img v-if="skuInfo.skuDefaultImgUrl" style="width: 117px;height: 148px;" :src="skuInfo.skuDefaultImgUrl" alt="">
        </div>
      </div>
      <div class="line">
        <div class="key">商品轮播图</div>
        <div class="value">
          <img v-if="skuInfo.swiperImg" style="height: 150px;width: 375px;" :src="skuInfo.swiperImg" alt="">
        </div>
      </div>
      <div class="line">
        <div class="key">商品详情图</div>
        <div class="value">
          <div class="skuImg" v-for="item in skuInfo.detailImgs">
            <img :src="item.imgUrl" alt="">
          </div>
        </div>
      </div>
      <div class="line">
        <div class="key">图示详情</div>
        <div class="value">
          <div class="skuImg" v-for="item in skuInfo.graphicalDetails">
            <img :src="item.url" alt="">
          </div>
        </div>
      </div>
      <div class="line">
        <div class="key">创建时间</div>
        <div class="value">{{skuInfo.createTime}}</div>
      </div>
      <div class="line">
        <div class="key">最近上架日期</div>
        <div class="value">{{skuInfo.shelvesTime}}</div>
      </div>
      <div class="line">
        <div class="key">选为精选商品：</div>
        <div class="value">
          <el-date-picker
                  size="small"
                  v-model="dailyPushDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="精选日期">
          </el-date-picker>
          <el-button slot="trigger" size="small" type="primary" style="margin-left: 10px;" @click="addDailyPush">选为精选</el-button>
        </div>
      </div>
      <div class="line">
        <div class="key">选为轮播图商品：</div>
        <div class="value">
<!--          <el-date-picker-->
<!--                  size="small"-->
<!--                  v-model="swiperDate"-->
<!--                  type="date"-->
<!--                  value-format="yyyy-MM-dd"-->
<!--                  placeholder="轮播日期">-->
<!--          </el-date-picker>-->
          <el-button slot="trigger" size="small" type="success" style="margin-left: 10px;" @click="addSwiper">选为轮播</el-button>
        </div>
      </div>
      <div class="line"></div>

    </div>
    <div class="but">
      <el-button type="danger" size="small" @click="backClick">返回</el-button>
    </div>
  </div>
</template>

<script>
  import {getSkuInfoById,newVue,addDailyPush,addSwiper} from "../../network/skuInfo";
  import {utilVue, successMsg, errorMsg} from "../../utils/util";

  export default {
    name: "skuInfoData",
    components: {},
    data(){
      return{
        skuInfoId:"",
        skuInfo:{
          pmsSkuClassify:{},
          labelValues:[],
          detailImgs:[],
          graphicalDetails:[],
          pmsExtras:[],
          merchants:{}
        },
        dailyPushDate: "",
        // swiperDate: ""
      }
    },
    methods:{
      aaa(){},
      backClick(){
        this.$router.back();
      },
      addDailyPush(){
        if (this.dailyPushDate===""){
          errorMsg("请选择精选日期")
          return;
        }
        let myDate = new Date();
        myDate = myDate.getFullYear()+"-"+(myDate.getMonth())+"-"+myDate.getDate();
        let dayNum = this.dateDiff(this.dailyPushDate,myDate)
        console.log(dayNum);
        if (dayNum<=0){
          errorMsg("该日期已过时")
          return;
        }
        addDailyPush(this.skuInfoId,dayNum)
      },
      addSwiper(){
         addSwiper(this.skuInfoId)
      },
      //比较两个日期相隔的天数
      dateDiff(sDate1, sDate2){    //sDate1和sDate2是2006-12-18格式
        var  aDate,  oDate1,  oDate2,  iDays;
        aDate   =  sDate1.split("-");
        oDate1 = new Date(aDate[0] , aDate[1]-1 ,aDate[2])   ; //转换为12-18-2006格式
        console.log(oDate1);
        aDate   =  sDate2.split("-");
        oDate2 = new Date(aDate[0] , aDate[1] , aDate[2]);
        console.log(oDate2);
        return  parseInt((oDate1  -  oDate2)/1000/60/60/24);    //把相差的毫秒数转换为天数
      }
  },
    created() {
      newVue.obj = this;
      utilVue.obj = this;
      this.common.HeaderLocationTwo.href = "/pmsSkuInfo/list";
      this.common.HeaderLocationTwo.name = "农商品管理";
      this.common.HeaderLocationThree.name = "农商品详情"
      if (this.$route.params.id != null) {
        this.skuInfoId = this.$route.params.id;

        getSkuInfoById(this.skuInfoId).then(res => {
          this.skuInfo = res.data;
        })
      }
    }
  }
</script>

<style scoped>
  @import "../../assets/css/data.css";

  .tag {
    display: inline-block;
    height: 30px;
    background-color: #67c23a;
    border-color: #e9e9eb;
    color: white;
    box-sizing: border-box;
    margin: 2px 6px 2px 0;
    padding: 0 8px;
    line-height: 30px;
  }

  .skuImg{
    width: 148px;
    height: 117px;
    display: inline-block;
    vertical-align: top;
    margin-right: 30px;
  }
  .skuImg img{
    width: 148px;
    height: 117px;
  }
</style>
